// Local constants
// Pages
export const PAGE_START = '/';
export const PAGE_DASHBOARD_EXPIRY_PARTICIPANTS = '/expiry_participants';
export const PAGE_DASHBOARD_PRIORITY_VISITS = '/priority_visits';
export const PAGE_DASHBOARD_PARTICIPANTS_TO_BE_UNENROLLED = '/to_be_unenrolled';
export const PAGE_DASHBOARD_DEPLOYMENT_STATUS = '/deployment_status';
export const PAGE_DASHBOARD_COLLECTION_STATUS = '/collection_status';
export const PAGE_DASHBOARD_DEPLOYMENT_PROGRESS = '/deployment_progress';
export const PAGE_DASHBOARD_GLOBAL_COLLECTION_PROGRESS = '/global_colllection_status';
export const PAGE_DASHBOARD_DATA_STREAM_QUALITY = '/data_stream_quality';
export const PAGE_DASHBOARD_SINGLE_COLLECTION_STATUS = '/single_collection_status';
export const PAGE_DASHBOARD_LAB_UPLOADS = '/lab_uploads';
export const PAGE_DASHBOARD_NAME_MATCHER = '/name_matcher';
export const PAGE_DASHBOARD_GOVEE_CODES = '/govee_codes';
export const PAGE_DASHBOARD_ACTION_ITEMS = '/participant_issues';
export const PAGE_PARTICIPANT_UNENROLL = '/participant_unenroll';
export const PAGE_DASHBOARD_DOCUMENTS = '/documents';

export const PAGE_DASHBOARD_EXHIBITION_DASHBOARDS_SELECT = '/exhibition_dashboards';
export const PAGE_DASHBOARD_EXHIBITION_FLIPPING_CARDS = `${PAGE_DASHBOARD_EXHIBITION_DASHBOARDS_SELECT}/flipping_cards`;

// Chart Constants
export const PARTICIPANTS = 'participants';

export const VALUE = 'value';
export const DATE = 'date';
export const CUMULATIVE_VALUE = 'cumulative_value';

export const DEBUG = `${process.env.REACT_APP_DEBUG}`.toUpperCase() === 'TRUE';
export const MAX_IDLE_MINUTES = 30;
export const TARGET_PARTICIPANTS = 100;

// Store Actions
export const SET_VALUE = 'SET_VALUE';
export const UPDATE_OBJECT_VALUE = 'UPDATE_OBJECT_VALUE';
export const RESET_ALL_DATASETS = 'RESET_ALL_DATASETS';

// Store Values
//
// Variables
export const IS_LOGGED_IN = 'last_log_in';
export const LAST_INTERACTION = 'last_interaction';
// The session token checkPassword mints. Lives in the non persistent store, so
// it dies on reload exactly like IS_LOGGED_IN does.
export const APP_TOKEN = 'app_token';
// The token the server mints, which the library sends straight to /api. Lives
// alongside APP_TOKEN and dies with it, so a reload starts a clean session.
export const API_TOKEN = 'api_token';
export const API_TOKEN_EXPIRY = 'api_token_expiry';
export const SELECTED_PARTICIPANT = 'SELECTED_PARTICIPANT';
export const FILTER_TEXT_EXPIRY_PARTICIPANTS = 'filter_text_expiry_participants';
export const FILTER_TEXT_ACTION_ITEMS = 'filter_text_issues';
// Language
// The selected locale. Unlike every other store value this one survives a
// reload, kept in localStorage by LanguageHooks rather than by persisting the
// whole store (the tokens above must not survive).
export const CURRENT_LOCALE = 'current_locale';
export const LOCALE_STORAGE_KEY = 'community_hats_locale';
export const DEFAULT_LOCALE = 'en';
export const SUPPORTED_LOCALES = ['en', 'es', 'hi', 'gu'];

export const USER_TYPE = 'user_type';
export const USER_TYPE_SEWA = 'sewa';
export const USER_TYPE_OUTSIDE_COLLABORATOR = 'outside_collaborator';
export const PROJECT_LOCATION = 'project_location';
export const LOCATION_TRACKER_LATEST_APP_VERSION = 'location_tracker_latest_app_version';
// Summary Constants

// Data Stream Quality Constants
export const SUMMARY_COVERAGE_INTERVALS = 'coverage_intervals';
export const SUMMARY_ACCURACY_INTERVALS = 'accuracy_intervals';
export const SUMMARY_HEART_RATE = 'heart_rate';
export const SUMMARY_TEMPERATURE = 'temperature';
export const SUMMARY_GEOLOCATION = 'geolocation';
export const SUMMARY_SLEEP = 'sleep';

// Levels of losing data
// Loosing Constants
export const MORE_30 = 'MORE_30';
export const MORE_20 = 'MORE_20';
export const MORE_10 = 'MORE_10';
export const MORE_0 = 'MORE_0';

// Chart constants
export const CHART_DATA = 'chart_data';
export const DOMAIN = 'domain';
export const TICKS = 'ticks';

// Exhibition Store Constants
export const EXHIBITION_FC_PARTICIPANT_DATA = 'EXHIBITION_FC_PARTICIPANT_DATA';
export const EXHIBITION_FC_SATELITE_WEATHER = 'EXHIBITION_FC_SATELITE_WEATHER';

export const EXHIBITION_FC_PARTICIPANT_DATA_STATUS = 'EXHIBITION_FC_PARTICIPANT_DATA_STATUS';
export const EXHIBITION_FC_SATELITE_WEATHER_STATUS = 'EXHIBITION_FC_SATELITE_WEATHER_STATUS';

export const EXHIBITION_FC_START_DATE = '2025-04-07 00:00:00'; // Inclusive
export const EXHIBITION_FC_END_DATE = '2025-04-14 00:00:00'; // Not Inclusive
export const EXHIBITION_FC_TIME_INTERVAL = 60; // Minutes
export const EXHIBITION_FC_FREQUENCY = 10; // seconds
export const EXHIBITION_FC_MIN_DATA_FREQUENCY = 15; // Minutes
